import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./MagicalBedtime.css";

import MBImg from "../../works_images/works2.png";
import MBImg1 from "../../works_images/works2.1.png";
import MBImg2 from "../../works_images/works2.2.png";
import MBImg3 from "../../works_images/works2.3.png";
import MBImg4 from "../../works_images/works2.4.png";
import MBImg5 from "../../works_images/works2.5.png";
import MBImg6 from "../../works_images/works2.6.png";

const ArrowLeft = ({ className, style, onClick }) => (
  <div
    className={`${className} custom-arrow left`}
    style={{ ...style }}
    onClick={onClick}
  >
    <FaChevronLeft />
  </div>
);

const ArrowRight = ({ className, style, onClick }) => (
  <div
    className={`${className} custom-arrow right`}
    style={{ ...style }}
    onClick={onClick}
  >
    <FaChevronRight />
  </div>
);

const MagicalBedtime = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");

  const settings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
  };

  const images = [
    { src: MBImg, alt: "My Magical Bedtime screenshot 1" },
    { src: MBImg1, alt: "My Magical Bedtime screenshot 2" },
    { src: MBImg2, alt: "My Magical Bedtime screenshot 3" },
    { src: MBImg3, alt: "My Magical Bedtime screenshot 4" },
    { src: MBImg4, alt: "My Magical Bedtime screenshot 5" },
    { src: MBImg5, alt: "My Magical Bedtime screenshot 6" },
    { src: MBImg6, alt: "My Magical Bedtime screenshot 6" },
  ];

  return (
    <div className="project-page-container MagicalBedtime-project">
      <div className="project-page-content">
        <button
          type="button"
          onClick={handleBack}
          className="back-button"
          aria-label="Back to Home"
        >
          &larr; Back to Home
        </button>

        <div className="project-header">
          <h1>My Magical Bedtime</h1>
          <p className="project-subtitle">
            An AI-powered, full-stack web application for generating
            personalized bedtime stories.
          </p>
        </div>

        <div className="project-main-content">
          <div className="project-left-column">
            <h2>About The Project</h2>
            <p>
              My Magical Bedtime is an interactive web application designed to
              bring the magic of storytelling to young children and their
              parents. This full-stack application, developed as{" "}
              <strong>a group project for a Software Engineering course</strong>
              , uses AI to generate unique, personalized bedtime stories. Users
              can customize the main character, theme, and setting to create a
              new adventure every night. Each story is complete with an
              AI-generated illustration and audio narration featuring read-along
              text highlighting. Parents can create a secure account to save
              their favorite stories to a personal gallery and manage content
              through parental controls.
            </p>
            <p>
              As the <strong>Design & Implementation Lead</strong> and{" "}
              <strong>Requirements Lead</strong>, I was primarily responsible
              for shaping the project's features and leading the development of
              the responsive React frontend.
            </p>

            <h2>Technical Deep Dive</h2>
            <p>
              The application is built with a secure client-server architecture
              using the MERN stack. The frontend, developed with React and Vite,
              provides a responsive and whimsical user interface designed to be
              intuitive for both parents and children. To protect user data and
              manage access, the frontend communicates with a dedicated Node.js
              backend server.
            </p>
            <p>
              The backend handles all business logic, including user
              registration and authentication using JWT and bcrypt,
              communication with the OpenAI API for generating story content,
              images, and audio, and all interactions with the MongoDB database.
              It exposes a RESTful API for all standard operations. This
              architecture ensures that sensitive operations, like fetching a
              user's private stories or updating parental controls, are securely
              protected and require proper authentication. The backend is
              containerized with Docker and deployed on Heroku, while the
              frontend is deployed on Netlify.
            </p>
          </div>

          <div className="project-right-column">
            <div className="project-image-container">
              <Slider {...settings}>
                {images.map((img, idx) => (
                  <div key={idx}>
                    <img
                      src={img.src}
                      alt={img.alt}
                      className="project-image"
                    />
                  </div>
                ))}
              </Slider>
              <div className="project-buttons">
                <a
                  href="https://velvety-entremet-8ac832.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-button"
                >
                  Website
                </a>
                {/* <a
                  href="YOUR_GITHUB_REPO_URL"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-button secondary"
                >
                  Code
                </a> */}
              </div>
            </div>
            <div className="project-technology-container">
              <h2>Technology used</h2>
              <ul>
                <li>
                  <strong>Frontend:</strong> React (Vite), JavaScript (ES6+),
                  CSS3, React Router
                </li>
                <li>
                  <strong>Backend:</strong> Node.js, Express.js, REST API
                </li>
                <li>
                  <strong>Database:</strong> MongoDB with Mongoose
                </li>
                <li>
                  <strong>AI Services:</strong> OpenAI (GPT-4, DALL-E, TTS)
                </li>
                <li>
                  <strong>Authentication:</strong> JSON Web Tokens (JWT), bcrypt
                </li>
                <li>
                  <strong>Deployment:</strong> Netlify (Frontend), Heroku
                  (Backend)
                </li>
                <li>
                  <strong>DevOps:</strong> Docker, GitHub Actions for CI/CD
                </li>
                <li>
                  <strong>Project Management</strong> Agile methodologies,
                  GitHub Projects for task tracking and sprints
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagicalBedtime;
